import type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';

/**
 * Shared DatePicker slot props configuration for consistent popper behavior
 * across all date pickers in the application.
 */
export const datePickerSlotProps: DatePickerProps['slotProps'] = {
  popper: {
    placement: 'bottom-start',
    disablePortal: false,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 4],
        },
      },
      {
        name: 'preventOverflow',
        options: {
          boundary: 'clippingParents',
          altAxis: true,
          padding: 8,
        },
      },
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['top-start', 'bottom-end', 'top-end'],
        },
      },
    ],
    sx: {
      zIndex: 1350,
    },
  },
  desktopPaper: {
    sx: {
      boxShadow: 3,
      maxHeight: '400px',
      overflow: 'auto',
    },
  },
};
